import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import { Carousel } from 'react-bootstrap';

import '../../assets/css/CollectionMainInfoPageVer.css'

import { AND, OR, NOT } from '../../config';
import Footer from "../../components/Footer";
import CollectionMaininfoPageCell from "../../components/CollectionMaininfoPageCell";

import TFAILogoMain from '../../assets/images/TFAI-logo-main.svg'
import bgPic3 from '../../assets/images/item2.jpg'

const Item = () => {
    const searchWord = localStorage.getItem('keyWord')// 查詢關鍵字
    const itemData = JSON.parse(localStorage.getItem('itemData'));
    const printPageRef = useRef();
    
    const wordArray = searchWord.split(new RegExp(`(${AND}|${OR}|${NOT})`, 'i'))
    let skipNext = false
    const searchArray = wordArray.filter((element) => {
        if (element === '' || element === AND || element === OR || skipNext) {
          skipNext = false;
          return false;
        } else if (element === NOT) {
          skipNext = true;
          return false;
        }
        return true;
    });
    
    // 判斷關鍵字是否需要添加 highlight 樣式
    const renderWithHighlight = (text) => {
        if (searchArray.length > 0 && text !== null) {
          const sortedArray = searchArray.sort((a, b) => b.length - a.length);
          const regex = new RegExp(sortedArray.join('|'), 'gi');
          // Matches array needed to maintain the correct letter casing
          const matches = [...text.matchAll(regex)];
          return text.split(regex).map((part, index) => (
            `${part}${index<matches.length ? `<div key={index} style="background-color: rgb(255, 255, 94); color: black; display: math;">${matches[index]}</div>` : ''}`
          )).join('');
        }
        return text;
    };
    
    const conditionCheck = (value) => {        
        if(value){
            let target = value.replace(/\s/g,"")
            if(target === '' || target === '無標註'){
                return false
            } else{
                return true
            }
        } else{
            return false
        }
    }

    const createIDInfo = (print) => {
        return itemData && conditionCheck(itemData.原始藏品編號) ?
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer">
                    <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"原始藏品編號 "}</div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.原始藏品編號) }} />
                        </div>
                    </div>
                </div>
            </div>
        :null
    }
    const createKeywordInfo = (print) => {
        return itemData &&(conditionCheck(itemData['功能-關鍵詞彙'])||conditionCheck(itemData.藏品類型分類第一級+itemData.藏品類型分類第二級+itemData.藏品類型分類第三級))?
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer">
                    {conditionCheck(itemData['功能-關鍵詞彙']) ?
                        <div style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"關鍵字 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <CollectionMaininfoPageCell>
                                    <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData['功能-關鍵詞彙']) }} />
                                </CollectionMaininfoPageCell>
                            </div>
                        </div>
                    :null}
                    {conditionCheck(itemData.藏品類型分類第一級+itemData.藏品類型分類第二級+itemData.藏品類型分類第三級) ?
                        <div style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"藏品類型分類 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.藏品類型分類第一級+" "+itemData.藏品類型分類第二級+" "+itemData.藏品類型分類第三級) }} />
                            </div>
                        </div>
                    :null}
                </div>
            </div>
        :null
    }
    const createSummary = (print) => {
        return itemData &&(conditionCheck(itemData['外部/外觀-描述/形式'])||conditionCheck(itemData['功能-描述'])||conditionCheck(itemData['功能-註釋']))?
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer">
                {conditionCheck(itemData['外部/外觀-描述/形式']) ?
                    <div style={{display:'flex'}}>
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"外觀描述 "}</div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <CollectionMaininfoPageCell>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData['外部/外觀-描述/形式']) }} />
                            </CollectionMaininfoPageCell>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData['功能-描述']) ? 
                    <div style={{display:'flex'}}>
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"功能描述 "}</div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <CollectionMaininfoPageCell>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData['功能-描述']) }} />
                            </CollectionMaininfoPageCell>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData['功能-註釋']) ? 
                    <div style={{display:'flex'}}>
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"功能註釋 "}</div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <CollectionMaininfoPageCell>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData['功能-註釋']) }} />
                            </CollectionMaininfoPageCell>
                        </div>
                    </div>
                :null}
                </div>
            </div>
        :null
    }
    const createSpecInfo = (print) => {
        return itemData &&(conditionCheck(itemData.尺寸)||conditionCheck(itemData.重量)||conditionCheck(itemData['材質-材質類別/名稱'])||conditionCheck(itemData['材質-顏色']))?
            <div className="CollectionMainInfoMajorArea">
                {conditionCheck(itemData.尺寸) ? 
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"尺寸 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                {itemData.尺寸+"公分(cm)"}
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.重量) ? 
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"重量 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                {itemData.重量+"公斤(kg)"}
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData['材質-材質類別/名稱']) ? 
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"材質 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                {itemData['材質-使用角色/角色']+" "+itemData['材質-材質類別/名稱']}
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData['材質-顏色']) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"顏色 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                {itemData['材質-顏色']}
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    
    const createMedia=()=>{
        return (
            <Carousel>
            {itemData && itemData.圖檔URL ?    
                getCarousel(itemData.圖檔URL)             
                : null
            }
            </Carousel>
        )
    }
    const getCarousel=(url)=>{
        let arrayUrl = url.split('|')
        return (  
            arrayUrl.map((url,index)=>{
                return(                     
                    <Carousel.Item key={index}>
                        <img alt="itemimg" src={url} style={{width:'100%',objectFit:'cover'}}></img>
                    </Carousel.Item>
                )
            })           
        )
    }
    
    const getTime = () => {
        let d = new Date()
        return d.toLocaleString()
    }

    return (<>
        <div className="TFAI-box">
            <div id="content-bg">
                <aside></aside>
                <div className="ctn-pic"><img alt="headPic" src={bgPic3} /></div>
            </div>
            <div className="container-xl">
                <div className="ctn-header">
                    <div className="ctn-logo d-none d-lg-block">
                        <Link to="/"><img src={TFAILogoMain} alt="TFAI logo" className="img-fluid"/></Link>
                    </div>
                    <div className="ctn-heading">
                        <h1><span>器物類藏品</span></h1>
                    </div>
                </div>
                <div className="ctn-area">
                    <div className="data-header row">  
                        <div className="col-12 col-md-7 col-lg-6">
                            <h2><div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.標題) }} /></h2>
                        </div>
                        <div className="col-12 col-md-5 col-lg-4 d-flex align-items-end share-links">   
                            <div className="media-share">        
                                <ReactToPrint
                                    trigger={()=>                         
                                        <svg className="bi bi-printer-fill" viewBox="0 0 16 16">
                                            <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
                                            <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                                        </svg>
                                    }
                                    content={()=>printPageRef.current}
                                />  
                            </div>  
                        </div>
                    </div>
                    <div className="data-body row">
                        <div className="col-12 col-md-7 col-lg-6">
                            <div >
                                {createIDInfo()}
                                {createKeywordInfo()}
                                {createSummary()}
                                {createSpecInfo()}
                            </div>
                        </div>
                        <div className="data-img col-12 col-md-5 col-lg-4 ">
                            {createMedia()}
                            <aside>
                                <span>典藏單位</span>
                                <p>國家電影及視聽文化中心</p>
                            </aside>
                            <aside>                            
                                <p style={{marginBottom:'2px',color:'black',fontWeight:'bolder'}}>
                                    藏品能否租借，本中心需視藏品狀態、有無權限等因素而評估，若需取用請填寫
                                    <a href="https://www.tfai.org.tw/downloads/rent">資料借出使用申請單</a>
                                    ，向本中心提出申請。
                                </p>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>        

            <div style={{ display: "none" }}>
                <div className="CollectionMainInfoMainBodyPrintPage" ref={printPageRef}>
                    <div>
                        <div style={{display:'flex'}}>
                            <div style={{position:'relative',width:'220px'}}>
                                <div style={{position:'absolute',bottom:'0px',fontSize:'12px'}}>
                                    {"國家電影及視聽文化中心 藏品檢索系統"}
                                </div>
                            </div>
                            <div>
                                <img alt="logo" src={TFAILogoMain}/>
                            </div>
                        </div>
                    </div>
                    <div style={{display:'flex'}}>
                        <div style={{width:'98%', margin:'1vw 1vw 0 1vw', fontSize:'20px'}}>
                            <div className="CollectionMainTitle" style={{borderBottom:'1px solid gray'}}>
                                <div className="CollectionMainInfoRow">
                                    <div className="MovieTitle" style={{fontSize:'20px'}}>                                        
                                        <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.標題) }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="CollectionMainInfoTableBody">                 
                        <div className='CollectionMainInfoTableColumnPrint'>
                            <div >
                                {createIDInfo(true)}
                                {createKeywordInfo(true)}
                                {createSummary(true)}
                                {createSpecInfo(true)}
                                {createMedia()}
                            </div>           
                            <div className="CollectionMainInfoAreaPageVer">
                                <div className="MovieRowTitle" style={{fontSize:'14px'}}>{"管理權"}</div>
                            </div>
                            <div className="CollectionMainInfoAreaPageVer">
                                <div className="CollectionMainInfoRowTitlePageVer" style={{width:'100%',fontSize:'12px'}}>{"國家電影及視聽文化中心"}</div>
                            </div>
                        </div>
                    </div>
                    <div style={{float:'right',paddingBottom:'50px'}} >
                        <div>
                            <div style={{display:'flex',fontSize:'12px'}}>
                                <div>列印時間 ：</div>
                                <div>{getTime()}</div>
                            </div>
                        </div>                
                    </div>
                </div>
            </div>  

            <Footer />
        </div>
    </>)
};

export default Item;